import PropTypes from 'prop-types'
import {
  connectInfiniteHits,
  connectStateResults,
} from 'react-instantsearch-dom'

import {
  Box,
  Button,
  Icon,
  Heading,
  LoadingSpinner,
  Text,
} from '@redriverpress/system'

import ClearRefinements from './ClearRefinements'

// Extension of Algolia's InfiniteHits component
// https://www.algolia.com/doc/api-reference/widgets/infinite-hits/react/
function InfiniteHits({
  emptyStateHeading,
  emptyStateMessage,
  hasMore,
  hitComponent,
  hits,
  hitsWrapper,
  isSearchStalled,
  refineNext,
  searching,
  searchResults,
  hitComponentProps,
}) {
  const WrapperComponent = hitsWrapper
  const HitComponent = hitComponent

  const isLoading = isSearchStalled || searching

  if (searchResults?.nbHits === 0) {
    return (
      <Box my={[4, null, null, 5]} textAlign='center'>
        <Heading as='h4' mb={3}>
          {emptyStateHeading}
        </Heading>
        <Text>{emptyStateMessage}</Text>
        <Box my={2}>
          <ClearRefinements clearsQuery />
        </Box>
      </Box>
    )
  }

  return (
    <>
      <WrapperComponent>
        {hits.map(hit => (
          <HitComponent hit={hit} key={hit.objectID} {...hitComponentProps} />
        ))}
      </WrapperComponent>
      {hasMore && (
        <Box textAlign='center' my={4}>
          <Button onClick={refineNext} disabled={isLoading}>
            <Text display='inline-block' pr={2}>
              View More
            </Text>
            {isLoading ? <LoadingSpinner /> : <Icon icon='arrow-down' />}
          </Button>
        </Box>
      )}
    </>
  )
}

InfiniteHits.defaultProps = {
  emptyStateHeading: 'No results found',
  emptyStateMessage:
    'We’re unable to find any results based on your search\u00A0terms.',
  hitsWrapper: ({ children }) => <div>{children}</div>, // eslint-disable-line react/prop-types
}

InfiniteHits.propTypes = {
  emptyStateHeading: PropTypes.string,
  emptyStateMessage: PropTypes.string,
  hitComponent: PropTypes.func.isRequired,
  hits: PropTypes.arrayOf(PropTypes.object),
  hitsWrapper: PropTypes.func,
  hasMore: PropTypes.bool,
  refineNext: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  hitComponentProps: PropTypes.object,
}

export default connectInfiniteHits(connectStateResults(InfiniteHits))
